import { CaToPay } from 'types/commande/commande.def';
import { UserPerfs } from 'types/user/user.def';
import { sanitizePrice } from '../number/sanitizeCalul';

export const userPerfstoTableMyResultData = (
  data: UserPerfs,
  caToPay: CaToPay,
  engagementRate: number
) => {
  const noteUser = data.note;
  const noteClasse = data.classe.note;
  return {
    legends: [
      'CA payé (hors port et "1 € ONG")',
      'CA impayé (CB, Mandats, Virements)',
      'Nombre de ventes impayées',
      'Ventes additionnelles (payées)',
      'Ventes pro (payées)',
      'Nombre de ventes (total)',
      `Taux d'engagement`
    ],
    me: [
      'Moi',
      sanitizePrice(noteUser.qteca.toString()) + ' €',
      sanitizePrice(caToPay?.eleve.toString()) + ' €',
      data.unpayedOrders,
      noteUser?.qterebond,
      noteUser?.qtepro,
      data.commandes,
      '\u200B'
    ],
    myClass: [
      'Ma classe',
      sanitizePrice(noteClasse.qteca.toString()) + ' €',
      sanitizePrice(caToPay?.classe.toString()) + ' €',
      data.classe.unpayedOrders,
      noteClasse?.qterebond,
      noteClasse?.qtepro,
      data.classe.commandes,
      (engagementRate * 100).toFixed(1) + ' %'
    ]
  };
};
